<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M4.75 5.875L5.40367 15.3532C5.45791 16.1397 6.11174 16.75 6.90011 16.75H13.0999C13.8882 16.75 14.5421 16.1397 14.5963 15.3532L15.25 5.875" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M3.625 5.5H16.375" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M7.05322 5.30966C7.31764 3.92309 8.53641 2.875 10 2.875C11.4637 2.875 12.6824 3.92309 12.9469 5.30966" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'DeleteItemIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>